<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/product-notifications/shared/product-notification-edit/product-notification-edit.component.ts
-->
<ng-template #anchor></ng-template>
